var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.47 43.77C32.32 44.13 31.1 44.33 29.83 44.33C23.16 44.33 17.75 38.92 17.75 32.25V27.42",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1699 20.17C22.3699 17.24 25.8799 15.34 29.8399 15.34C36.5099 15.34 41.9199 20.75 41.9199 27.42V32.25C41.9199 34.97 41.0199 37.48 39.4999 39.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5399 38.29L41.1899 36.39",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5399 21.37L41.1899 25.69H25.6899",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1201 38.29L18.4801 36.39",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9099 29.83H46.7499",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9199 29.83H17.7499",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7399 47.74L11.9199 11.92",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.83 55.16C43.8194 55.16 55.16 43.8194 55.16 29.83C55.16 15.8406 43.8194 4.5 29.83 4.5C15.8406 4.5 4.5 15.8406 4.5 29.83C4.5 43.8194 15.8406 55.16 29.83 55.16Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.66,
    height: 55.66,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreat);
export default __webpack_public_path__ + "static/media/threat.a023f67dd3c74f88a3bfcfd94da4ecc8.svg";
export { ForwardRef as ReactComponent };